<script lang="ts">
    import { Answer } from '../../types/Answer'

    import type { Field } from '../../types/Field'
    import type { State } from '../../types/State'
    import type { Stats } from '../../types/Stats'
    import { Formatter } from '../../util/Formatter'
    import { StatsCollector } from '../../util/StatsCollector'
    import StatsBar from '../StatsBar.svelte'
    import SectionResult from './SectionResult.svelte'

    export let path: [number]

    export let field: Field

    export let state: State

    let stats: Stats | null = null

    $: stats = StatsCollector.collect(state, [...path])

    let showStats = false
</script>

<div class="grid">
    <div class="intro" class:icon={field.icon} style="--icon:url('{field.icon}')">
        <h3><span>Handlungsfeld {path[0] + 1} — </span>{field.title}</h3>
        <button
            on:click={() => (showStats = !showStats)}
            class="elementor-button desktop {showStats ? 'chevron-up' : 'chevron-down'}"
        >
            Details ausblenden
        </button>
    </div>
    <div class="stats">
        {#if stats}
            <StatsBar {stats} size="normal" />
            <div>
                Sie haben <strong>{Formatter.formatPercent(stats[Answer.Yes] / stats.total)}</strong
                >
                der Fragen mit <strong>Ja</strong>,
                <strong>{Formatter.formatPercent(stats[Answer.MostlyYes] / stats.total)}</strong>
                mit <strong>Eher Ja</strong>,
                <strong>{Formatter.formatPercent(stats[Answer.MostlyNo] / stats.total)}</strong>
                mit <strong>Eher Nein</strong> und
                <strong>{Formatter.formatPercent(stats[Answer.No] / stats.total)}</strong>
                mit <strong>Nein</strong> beantwortet.
                <strong>{Formatter.formatPercent(stats[Answer.NotRelevant] / stats.total)}</strong> der
                Fragen waren nicht relevant für Ihre Einrichtung.
            </div>
        {/if}
    </div>
    <button
        on:click={() => (showStats = !showStats)}
        class="elementor-button mobile {showStats ? 'chevron-up' : 'chevron-down'}"
    >
        Details ausblenden
    </button>
    {#if showStats}
        {#each field.sections as section, i}
            <SectionResult {section} path={[...path, i]} {state} />
        {/each}
    {/if}
</div>
<div class="summary">
    <p>
        Wenn Sie dieses Handlungsfeld stärken wollen, nutzen Sie unsere Tools aus dem
        Praxisleitfaden.
    </p>
    <button class="elementor-button" on:click={() => window.open(field.link)}>
        Praxisleitfaden Handlungsfeld {path[0] + 1}
    </button>
</div>

<style lang="scss">
    .grid {
        display: grid;
        grid-template-columns: 1fr;
        gap: 2rem 5rem;
        margin-top: 5rem;

        @media (min-width: 790px) {
            grid-template-columns: 1fr 1fr;
        }
    }

    .intro {
        @media (min-width: 790px) {
            margin-bottom: 2rem;
        }

        h3 {
            margin-top: 0;
            margin-bottom: 0.5rem;
            font-size: 1.5rem;

            span {
                color: var(--color-primary);
            }
        }

        position: relative;
        &.icon:before {
            content: '';
            position: absolute;
            background-color: var(--color-orange);
            width: 4.125rem;
            height: 4.125rem;
            left: 1rem;
            top: 2rem;
            mask-size: contain;
            mask-position: center;
            mask-repeat: no-repeat;
            mask-image: var(--icon);
            @media (max-width: 790px) {
                content: initial;
            }
        }
    }
    .summary {
        max-width: 42rem;
    }

    @media (max-width: 789px) {
        .desktop {
            display: none;
        }

        .mobile {
            display: block;
        }

        .elementor-button.mobile {
            display: inline-flex;
        }
    }

    @media (min-width: 790px) {
        .desktop {
            display: block;
        }

        .elementor-button.desktop {
            display: inline-flex;
        }

        .mobile {
            display: none;
        }
    }
</style>
